<template>
  <nav
    v-if="subMenuListLength > 0"
    class="dn-navigation"
  >
    <div class="navigation-inner">
      <ul class="top-tasks">
        <template
          v-for="(subMenu, index) in subMenuList"
          :key="subMenu.label"
        >
          <li>
            <dn-link
              v-track-event="{
                eventName: 'Header',
                component: { zone: 'header', element: 'dn-navigation-menu', element_id: 'menu-navigation' },
                attributes: { element_position: `${index + 1}/${subMenuListLength}`, link_url: subMenu.link }
              }"
              class="pill"
              :href="subMenu.link"
              :text="subMenu.label || ''"
              :external="subMenu.external || true"
            />
          </li>
        </template>
      </ul>
    </div>
  </nav>
</template>

<script setup lang="ts">
const subMenuList = useRuntimeConfig().public?.config?.subMenuConfig || [];

const subMenuListLength = subMenuList.length || 0;

</script>

<style lang="scss">
.dn-navigation {
  position: relative;
  background-color: var(--color-header-top-bg);
  width: 100%;
  transition: all 0.3s linear;
  z-index: 8;

  ::-webkit-scrollbar {
    display: none;
  }

  @media only screen and (width >= 768px) {
    overflow-x: hidden;
    margin-inline: auto;
  }

  .navigation-inner {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    inline-size: 100%;
    margin: 0 auto;
    padding: 8px 0 12px;

    @media only screen and (width >= 980px) {
      padding: 16px 0;
    }

    .top-tasks {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
      width: 100%;
      list-style: none;
      overflow-x: auto;
      padding: 0 var(--site-padding);

      @media only screen and (width >= 980px) {
        justify-content: var(--navigation-alignment);
      }

      &::after {
        content: '';
        display: block;
        position: absolute;
        right: 0;
        top: 0;
        width: 40px;
        height: 100%;
        background: var(--color-header-top-bg);
        mask-image: linear-gradient(-90deg, rgb(0 0 0 / 100%), transparent);

        @media only screen and (width >= 1280px) {
          display: none;
        }
      }

      @media only screen and (width >= 1280px) {
        padding-inline-start: 0;
        max-width: var(--grid-width);
      }

      li {
        a {
          --dn-header-link_color: var(--dn-header-white-link_color, var(--color-button-secondary-default-fg));

          font-size: var(--typography-utility-m-font-size);
          font-family: var(--typography-utility-m-font-family);
          letter-spacing: var(--typography-utility-m-letter-spacing);
          background: var(--color-button-secondary-default-bg);
          border-color: var(--color-button-secondary-default-border);
          text-decoration: none;
          border-radius: 20px;
          padding: 8px 16px;

          @media only screen and (width >= 768px) {
            overflow-x: hidden;
            font-size: var(--typography-utility-m-font-size);
            letter-spacing: var(--typography-utility-m-letter-spacing);
          }

          &:hover,
          &:active {
            --dn-header-link_color__hover: var(--dn-header-white-link_color__hover, var(--color-button-secondary-hover-fg));

            background: var(--color-button-secondary-hover-bg);
            border-color: var(--color-button-secondary-hover-border);
          }

          &:active,
          &.active {
            --dn-header-link_color__active: var(--dn-header-white-link_color__active, var(--color-button-secondary-active-fg));

            background: var(--color-button-secondary-active-bg);
            border-color: var(--color-button-secondary-hover-border);
          }
        }
      }
    }
  }
}
</style>
